// frontend/src/pages/register/Register.jsx

import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./register.css";
import { Context } from "../../context/Context";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";
import { useRef, useEffect, useContext, useState } from "react";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

export default function Register() {
  const [user_name, setUsername] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const prefilledEmail = queryParams.get("email") || "";
  const prefilledInviteCode = queryParams.get("invite") || queryParams.get("inviteCode") || "";
  const [email, setEmail] = useState(prefilledEmail);
  const [inviteCode] = useState(prefilledInviteCode);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [agreedToEmails, setAgreedToEmails] = useState(false);
  const { dispatch } = useContext(Context);
  const navigate = useNavigate();
  const emailInputRef = useRef(null);
  const nameInputRef = useRef(null);

  const generateTempUsername = (name) => {
    const formattedName = name.toLowerCase().replace(/\s/g, "");
    const randomNumber = Math.floor(Math.random() * 9000) + 1000;
    const tempUsername = `${formattedName}${randomNumber}`;

    return tempUsername;
  };

  const prefilledPromoCodeRaw =
    queryParams.get("promo") ||
    queryParams.get("promoCode") ||
    queryParams.get("ref") ||
    "";

  const prefilledPromoCode = prefilledPromoCodeRaw.trim();

  useEffect(() => {
    if (prefilledPromoCode) localStorage.setItem("flow_promo", prefilledPromoCode);
  }, [prefilledPromoCode]);

  const [promoCode] = useState(
    (prefilledPromoCode || localStorage.getItem("flow_promo") || "").trim()
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      if (prefilledEmail === "" && emailInputRef.current) {
        emailInputRef.current.focus();
      } else if (nameInputRef.current) {
        nameInputRef.current.focus();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user_name.trim()) {
      toast.info("Please enter your name.");
      return;
    }

    dispatch({ type: "LOGIN_START" });
    try {
      const normalizedEmail = email.trim().toLowerCase();

      const res = await axios.post("/auth/register", {
        user_name,
        username: generateTempUsername(user_name),
        email: normalizedEmail,
        password,
        agreementToMarketing: agreedToEmails,
        inviteCode,
        promoCode,
      });
      if (res.status === 200 && res.data) {
        dispatch({ type: "LOGIN_SUCCESS", payload: res.data });
        localStorage.removeItem("flow_promo");
        navigate(`/username?user_id=${res.data.user.userId}`);
      } else {
        toast.info(res.data?.msg || "Signup failed");
      }
    } catch (err) {
      if (err.response && err.response.status === 409) {
        toast.error("This email is already registered. Please log in instead.");
      } else if (err.response && err.response.data && err.response.data.msg) {
        toast.error(err.response.data.msg);
      } else {
        toast.error("Internal server error");
      }
      dispatch({ type: "LOGIN_FAILURE" });
    }
  };

  const googleLogin = async (credentialResponse) => {
    dispatch({ type: "LOGIN_START" });

    try {
      const { credential } = credentialResponse;
      const decoded = jwtDecode(credential);

      // Extract user info from the decoded JWT token
      const { email: rawEmail, name, picture } = decoded;
      const email = rawEmail.trim().toLowerCase(); // Normalize email

      const res = await axios.post("/auth/google", {
        user_name: name,
        username: generateTempUsername(name),
        email,
        profilePic: picture,
        inviteCode,
        promoCode,
      });

      if (res.status !== 200) {
          toast.info(res.data.msg);
        }

      if (res.status === 200 && res.data) {
        dispatch({ type: "LOGIN_SUCCESS", payload: res.data });
        localStorage.removeItem("flow_promo");
        navigate("/");
      } else {
        toast.info(res.data?.msg || "Signup failed");
      }
    } catch (err) {
      dispatch({ type: "LOGIN_FAILURE" });
    }
  };

  return (
    <>
    <style>
      {`
        .main-content {
          display: none !important;
        }
      `}
    </style>
      <div className="page-container-register">
        <div className="left-container-register">
          <Link to="/">
            <img
              src={process.env.REACT_APP_AWS_S3_IMAGE_FRONTEND_URL + "/Logo_FLOW_New_Cropped_800x800.png"}
              alt="For Love of Writers Logo"
              className="logo-register"
            />
          </Link>
          <img
            src={process.env.REACT_APP_AWS_S3_IMAGE_FRONTEND_URL + "/bottom_image.jpg"}
            alt="Your Image"
            className="picture"
          />
        </div>
        <div className="right-container-register">
          <form onSubmit={handleSubmit} className="form-register">
            <h1>
              Sign Up
            </h1>
            <div className="input-container-register">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                autoComplete="email"
                name="email"
                id="email"
                placeholder="Email Address"
                ref={emailInputRef}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                enterKeyHint="next"
                required
              />

              <label htmlFor="name">Your Name</label>
              <input
                type="text"
                autoComplete="name"
                name="name"
                id="name"
                placeholder="Your Name"
                ref={nameInputRef}
                value={user_name}
                onChange={(e) => setUsername(e.target.value)}
                enterKeyHint="next"
                required
              />

              <label htmlFor="password">Password</label>
              <div  className="password-container-register">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  id="password"
                  placeholder="Password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                  enterKeyHint="go"
                  style={{ paddingRight: "40px" }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: 0
                  }}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
                <div className="remember-me-register" style={{ display: "flex" }}>
                  <input
                    type="checkbox"
                    className="input-register"
                    style={{ width: "19px", height: "19px", backgroundColor: "#C9CDD3" }}
                    checked={agreedToEmails}
                    onChange={(e) => setAgreedToEmails(e.target.checked)}
                    required
                  />
                  <p
                    style={{
                      paddingTop: "8px",
                      
                      fontWeight: 400,
                    }}
                  >
                    I agree to receive regular e-newsletters and e-mail marketing from For Love of Writers.*
                  </p>
                </div>

              <div style={{ justifyContent: "center", paddingTop: "20px" }}>
                <button type="submit" className="RegisterBtn">
                  Create Account
                </button>
              </div>
            </div>
            <p>
              Already have an account?{" "}
              <Link style={{ textDecoration: "none" }} to="/login">
                Log in
              </Link>
            </p>
            {/* {error && (
              <span style={{ color: "red", marginTop: "10px" }}>
                Something went wrong!
              </span>
            )} */}

            <div className="separator-register">
              <hr />
              <span>OR</span>
              <hr />
            </div>

            <div className="button-row">
              <div style={{ justifyContent: "center", paddingTop: "10px" }}>
                <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                  <GoogleLogin
                    shape="rectangular"
                    theme="filled_blue"
                    onSuccess={googleLogin}
                  />
                </GoogleOAuthProvider>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
